import moment from 'moment/moment.js';
import FetchApi from "./Functionapi";
const FetchApis = new FetchApi();

const isSuccess = (res) => res && Number(res.status) === 200 && !res.error;

// โหลดข้อมูลเอกสารต้นฉบับใหม่จาก server ตอนกดบันทึก (ไม่พึ่งค่าใน redux ที่อาจยังโหลดไม่ครบ / เรียงไม่ตรงกัน)
// return { headers: [[head], ...], details: [[detail...], ...] } รูปแบบเดียวกับใน redux เรียงตาม journalCodes
export async function loadGroupSourceData(journalCodes) {
    const results = await Promise.all(journalCodes.map(code => Promise.all([
        FetchApis.FethcGet(`/document/DocumentByCode/${code}`),
        FetchApis.FethcGet(`/document/DocumentDetailListByCode/${code}`)
    ])));

    const failed = journalCodes.filter((code, i) => {
        const [head, detail] = results[i];
        return !head || !head.data || head.data.length === 0 || !detail || !detail.data;
    });
    if (failed.length > 0) {
        throw new Error(`โหลดข้อมูลเอกสารต้นฉบับไม่สำเร็จ: ${failed.join(', ')} กรุณาลองใหม่อีกครั้ง`);
    }

    return {
        headers: results.map(([head]) => head.data),
        details: results.map(([, detail]) => detail.data)
    };
}

// เช็คว่าทุกเอกสารที่เลือกเป็น version ล่าสุด : return รายการข้อความแจ้งเตือน (ว่าง = ผ่าน)
export async function checkLatestGroup(journalIds) {
    const results = await Promise.all(journalIds.map(id => FetchApis.FethcGet(`/document/checkLatestRevise/${id}`)));
    const messages = [];
    results.forEach((res, i) => {
        if (!res || res.error) messages.push(`เอกสาร id ${journalIds[i]}: ตรวจสอบ version ล่าสุดไม่สำเร็จ`);
        else if (!res.isLatest) messages.push(res.message);
    });
    return messages;
}

// สร้างเอกสาร revise ทั้งกลุ่ม พร้อม copy detail / รูป spec / รูปเพิ่มเติม ให้ครบเหมือนต้นฉบับ
// ทำทีละเอกสารและรอทุก request เสร็จก่อน return
// datahearder : [[head], ...]   datadetail : detail ที่แก้แล้ว (array หรือ array ซ้อน) ของทุกเอกสาร
// return { created: [เลขเอกสารที่สร้าง], failed: [รายการที่ไม่สำเร็จ] }
export async function GetdataReviseAll(datahearder, datadetail, journalGroupID, saleApproved, flowId, typeEdit) {
    const timestampsnow = moment().format('YYYY-MM-DD HH:mm:ss');
    const allDetail = (datadetail || []).flat();
    const created = [];
    const failed = [];

    for (const headList of datahearder) {
        const head = headList && headList[0];
        if (!head) continue;

        // จับคู่ detail กับเอกสารด้วย JournalCode (ไม่ใช่ลำดับ index) ป้องกัน detail ไปลงผิดเอกสาร
        const details = allDetail
            .filter(d => d.JournalCode === head.JournalCode)
            .sort((a, b) => (parseInt(a.SlotNo, 10) || 0) - (parseInt(b.SlotNo, 10) || 0));

        try {
            const reviseCode = await reviseOneJournal(head, details, journalGroupID, saleApproved, flowId, timestampsnow, failed);
            if (reviseCode) created.push(reviseCode);
        } catch (err) {
            failed.push(`${head.JournalCode}: ${err.message}`);
        }
    }

    return { created, failed };
}

async function reviseOneJournal(head, details, journalGroupID, saleApproved, flowId, timestampsnow, failed) {
    const versionnow = (parseInt(head.Revise, 10) || 0) + 1;
    const reviseCode = `${head.StandardCode}-` + versionnow;

    // 1. สร้าง Header ก่อน : ถ้าไม่สำเร็จ (ไม่ใช่ version ล่าสุด / เลขซ้ำ / error) จะไม่สร้าง detail
    const objectheader = {
        ...head,
        JournalCode: reviseCode,
        JournalGroupID: journalGroupID,
        SaleAckUserID: saleApproved,
        FlowrunId: flowId,
        Revise: versionnow,
        statusflow: "101",
        stateflow: "1",
        stamptimeUpdate: timestampsnow
    };
    const res = await FetchApis.FethcPost(`/document/createReviseGroupDocument`, objectheader);
    if (!isSuccess(res) || !res.insertId) {
        failed.push(`${head.JournalCode}: ${(res && res.message) || 'สร้างเอกสาร revise ไม่สำเร็จ'}`);
        return null;
    }

    // ข้อมูลที่ copy ต้องเป็นของเจ้าของเอกสาร revise ไม่งั้น Change Flow จะลบทิ้ง
    const ownerId = head.UserIDConfirm;

    // 2. โหลดรูป spec / รูปเพิ่มเติมของต้นฉบับ
    const [specRes, imageRes] = await Promise.all([
        FetchApis.FethcGet(`/document/DocumentSpecificByCode/${head.JournalCode}`),
        FetchApis.FethcGet(`/journalImages/JouranlImagesByCode/${head.JournalCode}`)
    ]);
    if (!specRes || !imageRes) {
        failed.push(`${reviseCode}: โหลดรูปของเอกสารต้นฉบับไม่สำเร็จ`);
    }
    const specs = (specRes && specRes.data) || [];
    const headerImages = (imageRes && imageRes.data) || [];

    // 3. copy detail ทีละรายการ แล้ว copy รูป spec ของ detail นั้น (จับคู่ด้วย id detail เดิม)
    for (const detail of details) {
        const newDetail = await FetchApis.FethcPost(`/document/createDocumentdetail`, {
            ...detail,
            JournalID: "",
            UserIDConfirm: ownerId,
            ConfirmDateTime: timestampsnow,
            JournalCode: reviseCode
        });
        const newDetailId = newDetail && newDetail.data && newDetail.data[0] && newDetail.data[0].JournalID;
        if (!newDetailId) {
            failed.push(`${reviseCode}: Detail ลำดับ ${detail.SlotNo} (${detail.ItemID || '-'})`);
            continue;
        }

        const imageOfDetail = specs.filter(img => Number(img.JourId) === Number(detail.JournalID));
        for (const img of imageOfDetail) {
            const r = await FetchApis.FethcPost(`/document/createDocumentSpecification`, {
                JournalID: "",
                SlotNo: img.SlotNo,
                ItemID: img.ItemID,
                ItemName: img.ItemName,
                SlotNoSpec: img.SlotNoSpec,
                SubjectDetails: img.SubjectDetails,
                SubjectExtend: img.SubjectExtend,
                LocationPic: img.LocationPic,
                UserIdConfirm: ownerId,
                ConfirmDateTime: timestampsnow,
                StatusFacConfirm: "1",
                JournalCode: reviseCode,
                JourId: newDetailId
            });
            if (!isSuccess(r)) failed.push(`${reviseCode}: รูป Spec ${img.LocationPic} (Detail ลำดับ ${detail.SlotNo})`);
        }
    }

    // 4. copy รูปเพิ่มเติมของเอกสาร
    for (const img of headerImages) {
        const r = await FetchApis.FethcPost(`/journalImages/createJournalImages`, {
            JournalID: "",
            SlotNo: img.SlotNo,
            ItemID: img.ItemID,
            ItemName: img.ItemName,
            SlotNoSpec: img.SlotNoSpec,
            SubjectDetails: img.SubjectDetails,
            SubjectExtend: img.SubjectExtend,
            LocationPic: img.LocationPic,
            UserIdConfirm: ownerId,
            ConfirmDateTime: timestampsnow,
            StatusFacConfirm: '1',
            JournalCode: reviseCode,
            JourId: res.insertId
        });
        if (!isSuccess(r)) failed.push(`${reviseCode}: รูปเพิ่มเติม ${img.LocationPic}`);
    }

    return reviseCode;
}

// บันทึก note ของกลุ่ม (ค่าเดิม / ค่าใหม่) : รอทุก request เสร็จก่อน return
export async function CreateNoteGroupById(datalist, newdatalist, typeEdit, groupdcode) {

    if (typeEdit == '1') {

        var datalistnow = {
            typeProduct: datalist[0].PkDescription,
            itemId: datalist[0].ItemID,
            itemName: datalist[0].ItemName,
            typenote: '1',
            journalgroupId: groupdcode
        }

        var datalistnew = {
            typeProduct: newdatalist.PkDescription,
            itemId: newdatalist.ItemID,
            itemName: newdatalist.ItemName,
            typenote: '2',
            journalgroupId: groupdcode
        }

        await Promise.all([
            FetchApis.FethcPost(`/notejournalgroup/createnoteitem`, datalistnow),
            FetchApis.FethcPost(`/notejournalgroup/createnoteitem`, datalistnew)
        ]);
    }
    else if (typeEdit == '2') {
        var datatlist = {
            TypeBatch: datalist[0].TypeBatch,
            batchName1: datalist[0].Batch1,
            batchName2: datalist[0].Batch2,
            batchDetail1: datalist[0].BatchDetail1,
            batchDetail2: datalist[0].BatchDetail2,
            batchExample1: datalist[0].BatchExample1,
            batchExample2: datalist[0].BatchExample2,
            numbers: datalist[0].BatchNo,
            typenote: '1',
            journalgroupId: groupdcode
        }

        await Promise.all([
            FetchApis.FethcPost(`/notejournalgroup/creatnotebatch`, datatlist),
            ...newdatalist.map(element => FetchApis.FethcPost(`/notejournalgroup/creatnotebatch`, {
                TypeBatch: element.TypeBatch,
                batchName1: element.batchName1,
                batchName2: element.batchName2,
                batchDetail1: element.batchDetail1,
                batchDetail2: element.batchDetail2,
                batchExample1: element.batchExample1,
                batchExample2: element.batchExample2,
                numbers: element.numbers,
                typenote: '2',
                journalgroupId: groupdcode
            }))
        ]);
    }

}
